export default {
    /**
     * Create an empty dunning plan
     * 
     * @param {Object} plan
     * @param {String} doctype
     * @returns {Promise}
     */
    createPlan(plan, doctype) {
        return new Promise((resolve, reject) => {
            plan.doctype = doctype
            SellsyJS.WebServiceCaller.post(
                '/rest/documents/prefs/dunnings',
                {},
                plan,
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Update dunning plan param
     * 
     * @param {Object} plan
     * @returns {Promise}
     */
    updatePlan(plan) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.put(
                `/rest/documents/prefs/dunnings/${plan.id}`,
                {},
                plan,
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Set no default dunning plan
     * 
     * @param {Object} plan
     * @returns {Promise}
     */
    setNoDefaultPlan(doctype) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/rest/documents/${doctype}/noMainPlan`,
                {},
                {},
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Delete dunning all plan
     * 
     * @param {Number} planId
     * @returns {Promise}
     */
    deletePlan(planId) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.del(
                `/rest/documents/prefs/dunnings/${planId}`,
                {},
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Create dunning step
     * 
     * @param {Number} planId
     * @returns {Promise}
     */
    createStep(planId, step) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/rest/documents/prefs/dunnings/${planId}/step`,
                {},
                step,
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * update dunning step in plan
     * 
     * @param {Number} planId
     * @returns {Promise}
     */
    updateStep(planId, step) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.put(
                `/rest/documents/prefs/dunnings/${planId}/step/${step.id}`,
                {},
                step,
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * delete dunning step in plan
     * 
     * @param {Number} planId
     * @returns {Promise}
     */
    deleteStep(planId, stepId) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.del(
                `/rest/documents/prefs/dunnings/${planId}/step/${stepId}`,
                {},
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Search staff with partial name
     * 
     * @param {String} query
     * @returns {Promise}
     */
    autoCompleteStaff(query) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(
                '/rest/staffs/autocomplete',
                {q:query},
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Search staff with partial name
     * 
     * @param {Number} id
     * @returns {Promise}
     */
    getStaff(id) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.get(
                `/rest/staffs/${id}`,
                {},
                (data) => {resolve(data)}, 
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Init dunning plan for a doctype
     * 
     * @param {String} doctype
     * @returns {Promise}
     */
    initDunning(doctype) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/rest/documents/prefs/dunnings-init/${doctype}`,
                {},
                {},
                (data) => {resolve(data)},
                (error) => {reject(error)}
            );
        })
    },

    /**
     * Enable or disable dunning for a doctype
     * 
     * @param {String} doctype
     * @returns {Promise}
     */
    toggleStatus(doctype) {
        return new Promise((resolve, reject) => {
            SellsyJS.WebServiceCaller.post(
                `/rest/documents/prefs/dunnings/toggle`,
                {},
                {"doctype": doctype},
                (data) => {resolve(data)},
                (error) => {reject(error)}
            );
        })
    },
}